import { cn } from "@Core/Helpers";
import React, { ComponentProps } from "react";

const ModalBody = (
    { className, ...props }: ComponentProps<"div">
) => (
    <div
        className={cn('grow p-3', className)}
        {...props}
    />
);

ModalBody.displayName = 'ModalBody';

export default ModalBody;
